/*                                      */

/**
 *
 *
 */
export const VERSION = '5.39.4';
export const PUBLIC_VERSION = '5';
